"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateName = void 0;
var generateName = function (title, givenName, familyName) {
    var filteredItems = [title, givenName, familyName].filter(function (arg) {
        return Boolean(arg);
    });
    return filteredItems.length === 0 ? null : filteredItems.join(' ');
};
exports.generateName = generateName;
